module.exports = __webpack_public_path__ + "static/img/logo_14.2084ff0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_14.png
// module id = IYpd
// module chunks = 1